var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"falcon__view falcon__view--complaint-form"},[_c('div',{staticClass:"view__header"},[_c('h1',{staticClass:"header__title"},[_vm._v(_vm._s(_vm.title))])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }